import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, FormSelect } from 'react-bootstrap';
import SupplierDataService from "./services/supplier.service";
import { Navigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useEffect } from 'react';
import { IoIosArrowBack } from "react-icons/io";

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const EditSupliersPage = (props) => {    
  let params = useParams();
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [supplierid, setSupplierid] = useState(params.id);
  const [suppliername, setSuppliername] = useState('');
  const [contactperson, setContactperson] = useState('');
  const [contactphone, setContactphone] = useState('');
  const [contactemail, setContactemail] = useState('');

  const onChangeSupplierName = (e) => {
    setSuppliername(e.target.value);
  } 

  const onChangeContactPerson = (e) => {
    setContactperson(e.target.value);
  } 
  
  const onChangeContactPhone = (e) => {
    setContactphone(e.target.value);
  } 

  // This has a slight issue. It does not update when selecting all the text and pressing DEL key..
  // It works with BACKSPACE if letters are removed one by one
  // Or with DEL also one by one from the beginning of the text
  const onChangeContactEmail = (e) => {
    setContactemail(e.target.value);    
  } 

  const handleValidations = (e) => {
    if (suppliername.length == 0 || contactperson.length ==0) {
      setErrmessage('There are empty required fields.');
      setShowerror(true);
      return;
    }
    if (contactemail) {
      if (!/\S+@\S+\.\S+/.test(contactemail)) {
        setErrmessage('Email is invalid.');
        setShowerror(true);
        return;
      }      
    }
    saveSupplier();
  }

  useEffect(() => {
    retrieveSupplier(supplierid);  
  }, [])

  const retrieveSupplier = (supplierid) => {
    SupplierDataService.get(supplierid)
      .then(response => {
        setSuppliername(response.data.suppliername);
        setContactperson(response.data.suppliercontactperson);
        setContactphone(response.data.suppliercontactphone);
        setContactemail(response.data.suppliercontactemail);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }


  let saveSupplier = ()  =>{   
    var data = {
        suppliername: suppliername,
        suppliercontactperson: contactperson,
        suppliercontactphone: contactphone,
        suppliercontactemail: contactemail,
    }    
    
    SupplierDataService.update(params.id, data)
    .then(response => {
      setSubmitted(true);
      setSuccmessage('Supplier has been updated. Redirecting to supplier list...');
      setShowsuccess(true);
      window.location.assign('/suppliers');
    })
    .catch(e => {
      console.log(e);
    })        
  }  

  const goToSuppliersList = (e) => {
    window.location.assign('/suppliers')
  }
  
  return (
    <>
      <Container>
        <Row className='mb-2'>
          <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
          <hr/>
          <h1 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>EDIT SUPPLIER</h1>
          <Col lg={true}>
            <FormLabel className='mb-2'>Supplier Name:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="suppliername" id="suppliername" onChange={onChangeSupplierName} defaultValue={suppliername}></FormControl>
          </Col>

          <Col lg={true}>
            <FormLabel className='mb-2'>Contact Person:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="contactperson" id="n" onChange={onChangeContactPerson} defaultValue={contactperson}></FormControl>
          </Col>          

          <Col lg={true}>
            <FormLabel className='mb-2'>Phone:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="contactphone" id="contactphone" onChange={onChangeContactPhone} defaultValue={contactphone}></FormControl>
          </Col>  

          <Col lg={true}>
            <FormLabel className='mb-2'>Email:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="contactemail" id="contactemail" onChange={onChangeContactEmail} defaultValue={contactemail}></FormControl>
          </Col>  

        </Row>
        <hr/>
        <Row className='mb-2'>
          <Col className='col-md-3'>
            <Button id='saveItem' onClick={handleValidations}>Save Supplier</Button>            
            <Button className='m-2' id='backToSuppliersList' onClick={goToSuppliersList}><IoIosArrowBack/></Button>            
          </Col>
        </Row>  
        {showerror && (
          <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
            <Alert.Heading>Error</Alert.Heading>
            <p>{errmessage}</p>
          </Alert>      
        )}
        {showsuccess && (
          <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
            <Alert.Heading>Done</Alert.Heading>
            <p>{succmessage}</p>
          </Alert>      
        )}     
         {submitted ? (<Navigate push to="/suppliers"/>) : null }                                     
      </Container>    
    </>
  )

}

export default EditSupliersPage;

